'use strict';

module.exports = {
  name: 'Index-Exchange',
  refresh: function refresh() {
    return null;
  },

  postRegistrationScript: function postRegistrationScript() {
    var scriptUrl = 'https://js-sec.indexww.com/ht/ls-legacy.js';

    return '<!--Index_beta Request-->\r\n<script async src=\'' + scriptUrl + '\'></script>\r\n<!-- Index Request -->';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvSW5kZXhFeGNoYW5nZUV4dGVuc2lvbl9iZXRhLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJuYW1lIiwicmVmcmVzaCIsInBvc3RSZWdpc3RyYXRpb25TY3JpcHQiLCJzY3JpcHRVcmwiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE9BQU9DLE9BQVAsR0FBaUI7QUFDZkMsUUFBTSxnQkFEUztBQUVmQyxXQUFTLG1CQUFNO0FBQ2IsV0FBTyxJQUFQO0FBQ0QsR0FKYzs7QUFNZkMsMEJBQXdCLGtDQUFNO0FBQzVCLFFBQU1DLFlBQVksNENBQWxCOztBQUVBLGlFQUEwREEsU0FBMUQ7QUFDRDtBQVZjLENBQWpCIiwiZmlsZSI6IkluZGV4RXhjaGFuZ2VFeHRlbnNpb25fYmV0YS5qcyIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0ge1xuICBuYW1lOiAnSW5kZXgtRXhjaGFuZ2UnLFxuICByZWZyZXNoOiAoKSA9PiB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH0sXG5cbiAgcG9zdFJlZ2lzdHJhdGlvblNjcmlwdDogKCkgPT4ge1xuICAgIGNvbnN0IHNjcmlwdFVybCA9ICdodHRwczovL2pzLXNlYy5pbmRleHd3LmNvbS9odC9scy1sZWdhY3kuanMnO1xuXG4gICAgcmV0dXJuIGA8IS0tSW5kZXhfYmV0YSBSZXF1ZXN0LS0+XFxyXFxuPHNjcmlwdCBhc3luYyBzcmM9JyR7c2NyaXB0VXJsfSc+PC9zY3JpcHQ+XFxyXFxuPCEtLSBJbmRleCBSZXF1ZXN0IC0tPmA7XG4gIH1cbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Extensions/IndexExchangeExtension_beta.js
// module id = 1521
// module chunks = 0